import React, { useState, useEffect } from 'react';
import { Star, Quote } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
export const TestimonialsSection: React.FC = () => {
  const isMobile = useIsMobile();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const testimonials = [{
    name: "Sarah M.",
    location: "California",
    quote: "Found my perfect policy in under 5 minutes. No pushy salespeople.",
    rating: 5,
    date: "Dec 2024"
  }, {
    name: "Mike R.",
    location: "Texas",
    quote: "Saved me $200/month! The AI understood my needs perfectly.",
    rating: 5,
    date: "Nov 2024"
  }, {
    name: "Jennifer L.",
    location: "Florida",
    quote: "As a single mom, I needed coverage fast. Safurra delivered.",
    rating: 5,
    date: "Jan 2025"
  }];

  // Auto-rotate testimonials on mobile
  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [isMobile, testimonials.length]);
  if (isMobile) {
    const testimonial = testimonials[currentTestimonial];
    return <section className="bg-primary-light/50 py-[50px]">
        <div className="container mx-auto px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              What Our Customers Say
            </h2>
          </div>
          
          <div className="max-w-sm mx-auto">
            <div className="bg-background rounded-xl p-6 border border-border text-center">
              {/* Rating */}
              <div className="flex items-center justify-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-4 w-4 text-primary fill-current" />)}
              </div>
              
              {/* Quote */}
              <p className="text-sm text-foreground leading-relaxed mb-4">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="text-xs text-muted-foreground">
                <span className="font-medium">{testimonial.name}</span> • {testimonial.date}
              </div>
            </div>
            
            {/* Dots indicator */}
            <div className="flex justify-center mt-4 space-x-2">
              {testimonials.map((_, index) => <div key={index} className={`w-2 h-2 rounded-full ${index === currentTestimonial ? 'bg-primary' : 'bg-primary/30'}`} />)}
            </div>
          </div>
        </div>
      </section>;
  }
  return <section className="bg-primary-light/50 py-[70px]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            Trusted by Families Everywhere
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            See what real customers say about their Safurra experience
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-background rounded-2xl p-8 shadow-sm border border-border hover:shadow-lg transition-shadow duration-300">
              {/* Rating */}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-5 w-5 text-primary fill-current" />)}
              </div>
              
              {/* Quote */}
              <div className="mb-6 relative">
                <Quote className="h-8 w-8 text-primary/20 absolute -top-2 -left-2" />
                <p className="text-foreground leading-relaxed pl-6">
                  "{testimonial.quote}"
                </p>
              </div>
              
              {/* Author */}
              <div className="flex items-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-foreground">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};